

<div class="col-sm-12" style="padding:10px;display:none">

  <div class="row">
    <div class="col-sm-3">
      <label>From</label>
      <input id="Txt_FromDate" type="Date" class="form-control" autocomplete="off">
    </div>
    <div class="col-sm-3">
      <label>To</label>
      <input id="Txt_ToDate" type="Date" class="form-control" autocomplete="off">
    </div>

    <div class="col-sm-3">
      <br>
      <span class="btn btn-outline-info waves-effect waves-light" title="Get" id="btnGet" (click)="GetDashboardDetails()">Search</span>
    </div>
  </div>
</div>

<button type="button" id="btnPopupDT" class="btn btn-block btn-primary float-sm-right" (click)="showInfoPopUp()" style="display:none">POP-UP</button>
<button type="button" id="btnLoadList" (click)="autoRefreshData()" style="display:none">Refresh</button>
<button type="button" id="btnDropChange" class="btn btn-block btn-primary float-sm-right" (click)="allocate()" style="display:none">DropChange</button>
<button type="button" id="btnArticleAllocate" (click)="articleAllocate()" style="display:none">ArticleAllocate</button>

<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">

        <div id="divMainFilterDash" class="col" style="display:none">
          <div class="row">
            <div class="col-sm-6">
              <label>Journals</label>
              <select id="lstJournals" class="form-control" multiple onchange="$('#btnGetVolumeIssues').trigger('click');">
                <!--<option *ngFor="let item of journalList" value={{item.ID}}>
                  {{item.Acronym}}
                </option>-->
              </select>
            </div>
            <div class="col-sm-2">
              <label>Volume</label>
              <select id="lstVolume" class="form-control">
                <!-- <option *ngFor="let item of volumeList" value={{item.ID}} [selected]="item.ID==0">
                  {{item.Volume}}
                </option>-->
              </select>
            </div>
            <div class="col-sm-2">
              <label>Issue</label>
              <select id="lstIssue" class="form-control">
                ">
                <!--<option *ngFor="let item of issueList" value={{item.ID}} [selected]="item.ID==0">
                  {{item.Issue}}
                </option>-->
              </select>
            </div>
            <div class="col-sm-2">
              <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Get" (click)="getFiltered()">Search</button>
              on
              <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
            </div>
          </div>
        </div>


        <!-- Nav tabs -->
        <ul class="nav nav-tabs nav-tabs-custom" role="tablist" *ngIf="!HideGraphView">
          <li class="nav-item">
            <a class="nav-link active" data-bs-toggle="tab" href="#list-view" role="tab" title="View List" (click)="GetViewList('List')">
              Table View
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" href="#graph-view" role="tab" title="View Graph" (click)="GetViewList('Graph')">
              Graph View
            </a>
          </li>
        </ul>

        <!-- Tab panes -->
        <div class="tab-content">

          <div id="list-view" class="tab-pane active" role="tabpanel">
            <div class="row">


              <!--Issue Details List-->
              <div class="col-sm-10" id="divIssueDetails" style="display:none">
                <h3 class="card-title">Issue Details</h3>

                <div class="page-title-right" style="display:none">
                  <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item" style="padding-right: 10px;">
                      <button type="button" class="btn btn-outline-info waves-effect waves-light" title="Refresh" (click)="GetJournalIssue()"><i class="fa fa-folder"></i>  Refresh</button>
                    </li>
                  </ul>
                </div>

                <div id="LoadingImageDashJrlIssue">
                  <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
                </div>

                <div id="tblJrlIssue" style="top: -20px; position: relative;">
                  <table #dataTableJrlIssue class="display" style="width:100%"></table>
                </div>
              </div>

              <!--Article Details List-->
              <div class="col-sm-10" id="divArticleDetails">
                <div id="divDashArticleInfo">
                  <h3 class="card-title">{{ArticleListTitle}}</h3>

                  <div class="page-title-right" style="display:none">
                    <ul class="nav nav-pills" role="tablist">
                      <!--<li class="nav-item" style="padding-right: 10px;">
                        <button type="button" class="btn btn-outline-danger waves-effect waves-light btnOverDue" title="Click View OverDue Only" (click)="GetArticleList('overDue')">&nbsp; Over Due</button>
                      </li>
                      <li class="nav-item" style="padding-right: 10px;">
                        <button type="button" class="btn btn-outline-success waves-effect waves-light btnTodayDue" title="Click View TodayDue Only" (click)="GetArticleList('todayDue')">&nbsp; Due Today</button>
                      </li>-->
                      <li class="nav-item" style="padding-right: 10px;">
                        <button type="button" class="btn btn-outline-info waves-effect waves-light" title="Refresh" (click)="GetJournalArticleStage()">
                          <i class="fa fa-folder"></i>  Refresh
                        </button>
                      </li>
                    </ul>
                  </div>

                  <app-articlemeta></app-articlemeta>

                  <div id="LoadingImageDashArt">
                    <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
                  </div>
                  <div id="tblArticleList" style="top: -20px; position: relative;">
                    <table #dataTableArticle class="display" style="width:100%"></table>
                  </div>

                  <div id="tblArticleAnnual" style="top: -10px; position: relative; display: none;">
                    <div class="col row">
                      <div class="col-sm-3">
                        <label>From</label>
                        <input id="Txt_JBFromDate" type="Date" class="form-control" autocomplete="off">
                      </div>
                      <div class="col-sm-3">
                        <label>To</label>
                        <input id="Txt_JBToDate" type="Date" class="form-control" autocomplete="off">
                      </div>
                      <div class="col-sm-11">
                        <label for="ddl_ProjectManager">Project Manager<em>*</em></label>
                        <select id="ddl_ProjectManager" class="form-control" multiple>
                          <option *ngFor="let item of modelData.ProjectManagerList" value={{item.ProjectManager}}>
                            {{item.ProjectManager}}
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-1">
                        <br>
                        <span class="btn btn-outline-info waves-effect waves-light" title="Get" id="btnJBGet" (click)="GetJournalArticleStage('JournalBudget',false)">Get</span>
                      </div>
                    </div>

                    <table #dataTableArticleAnnual class="display" style="width:100%"></table>
                  </div>

                  <!--Ingestion & Ucc List-->
                  <div id="tblIngestionList" style="top: -20px; position: relative; display: none;">
                    <table #dataTableIngestion class="display" style="width:100%;"></table>
                  </div>


                  <!--Customer API Failed List-->
                  <div id="tblCustomerApiFailed" style="top: -20px; position: relative; display: none;">
                    <table #dataTableCustomerApiFailed class="display" style="width:100%;"></table>
                  </div>

                </div>
              </div>

              <!--Summary List-->
              <div id="divSummaryList" class="col-sm-2" *ngIf="!HideSummaryPanel">

                <h3 class="card-title">Summary</h3>

                <div class="page-title-right">
                  <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item" style="padding-right: 10px;">
                      <button type="button" class="btn btn-outline-info waves-effect waves-light" title="Refresh" (click)="GetSummartItem()">
                        <i class="fa fa-retweet"></i>
                      </button>
                    </li>
                  </ul>
                </div>

                <div id="LoadingImageDashSummary">
                  <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
                </div>

                <div class="col-sm-12" id="divSummaryitem" style="overflow: hidden; overflow-y: auto; margin-left: -12px;">
                  <div class="col" *ngFor="let item of modelData.ArticleSummary">
                    <div class="row" style="white-space:nowrap;padding:5px">
                      <div class="col-sm-6">
                        <h6 class="mb-1" data-id="{{item.Icon}}">{{item.SummaryName}}</h6>
                      </div>
                      <div class="col-sm-6" style="text-align:right;">
                        <h5 class="small-box-footer spFilter" id="span{{item.Icon}}"
                            attr.data-summaryname="{{item.SummaryName}}" (click)="LoadGridByType(item.Icon)">
                          <span>{{item.ArtCount}}</span>
                        </h5>
                      </div>
                    </div>
                    <hr />
                  </div>
                </div>

              </div>


              <div id="divArticleInfo" class="modal" style="position:fixed !important">
                <div class="modal-dialog modal-xl custome-modal">
                  <div class="modal-content" id="modal_contentArt">
                    <div class="modal-header">
                      <h4 class="modal-title">Article Status</h4>
                      <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
                    </div>
                    <div class="modal-body">
                      <app-articleinfo></app-articleinfo>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                    </div>
                  </div>
                </div>
              </div>


              <!--Ingestion & Ucc Log-->
              <div id="divLogInfo" class="modal" [style.display]="modelData.showModal ? 'block' : 'none'">
                <div class="modal-dialog modal-lg">
                  <!-- Modal content-->
                  <div class="modal-content" id="modal_contenLog">
                    <div class="modal-header">
                      <h4 class="modal-title">{{modelData.title}} - {{modelData.ingestTitle}}</h4>
                      <button type="button" class="close" data-dismiss="modal" (click)="hideIngestionLog()">×</button>
                    </div>
                    <div class="modal-body modalHeight">
                      <div class="row">
                        <div class="col-sm-12">
                          <table class="tblMainLog">
                            <tbody>
                              <tr>
                                <td colspan="2" class="clsHeader">Ingestion</td>
                              </tr>
                              <tr><td>Status</td><td>{{modelData.ingestStatus}}</td></tr>
                              <tr><td>Start Date</td><td>{{modelData.ingestStartDate}}</td></tr>
                              <tr><td>Completed Date</td><td>{{modelData.ingestCompleteDate}}</td></tr>
                              <tr><td>Remarks</td><td><div class="col row" innerHTML="{{modelData.ingestDescription}}"></div></td></tr>

                              <tr><td colspan="2" class="clsHeader">Usability &amp; Completeness Check</td></tr>
                              <tr><td>Status</td><td>{{modelData.uccStatus}}</td></tr>
                              <tr><td>Start Date</td><td>{{modelData.uccStartDate}}</td></tr>
                              <tr><td>Completed Date</td><td>{{modelData.uccCompleteDate}}</td></tr>
                              <tr><td>Remarks</td><td><div class="col row" innerHTML="{{modelData.uccDescription}}"></div></td></tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideIngestionLog()">Close</button>
                    </div>
                  </div>
                </div>
              </div>

              <!--Customer API Failed Author List -->
              <div id="divAuthorDataList" class="modal" [style.display]="modelData.showAuthorDataModal ? 'block' : 'none'">
                <div class="modal-dialog modal-xl custome-modal">
                  <!-- Modal content-->
                  <div class="modal-content" id="modal_contenAuthorList">
                    <div class="modal-header">
                      <div class="response-inline" *ngIf="apiMessage" [title]="apiMessage">
                        <h5 class="modal-title">{{authorDatapopupTitle}}</h5>
                        <strong>Response:</strong>
                        {{ apiMessage | slice:0:500 }}{{ apiMessage.length > 500 ? '...' : '' }}
                      </div>

                      <button type="button" class="close" data-dismiss="modal" (click)="hideAuthorData()">×</button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-sm-12">
                          <form [formGroup]="form">
                            <div class="row tblAuthorData col-md-12 fixTableHead">
                              <table class="table table-bordered">
                                <thead style="background:#cfe8ff">
                                  <tr>
                                    <th>SlNo</th>
                                    <th style="display:none">Id</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Primary Email</th>
                                    <th>Corrs. Author</th>
                                    <th>RinggoldId</th>
                                    <th>RinggoldInst</th>
                                    <th>Address 1</th>
                                    <th>City</th>
                                    <th>State</th>
                                    <th>Country</th>
                                    <th>Pincode</th>
                                  </tr>
                                </thead>

                                <tbody formArrayName="contributors">
                                  <tr *ngFor="let c of contributors.controls; let i=index" [formGroupName]="i">
                                    <td>{{ c.get('sequenceNo')?.value }}</td>
                                    <td style="display:none">{{ c.get('id')?.value }}</td>
                                    <td><input class="form-control inputWidth" formControlName="givenNames"></td>
                                    <td><input class="form-control inputWidth" formControlName="surname"></td>
                                    <td><input class="form-control inputWidth" formControlName="primaryEmail"></td>

                                    <td class="text-center">
                                      <input type="checkbox"
                                             formControlName="isCorresponding"
                                             (change)="onCorrespondingChange(i)">
                                    </td>

                                    <td><input class="form-control inputWidth" formControlName="ringgoldId"></td>
                                    <td><input class="form-control inputWidth" formControlName="ringgoldInstitution"></td>
                                    <td><input class="form-control inputWidth" formControlName="address1"></td>
                                    <td><input class="form-control inputWidth" formControlName="city"></td>

                                    <td>
                                      <select class="form-control inputWidth" formControlName="state">
                                        <option selected value="">Select State</option>
                                        <option *ngFor="let item of states" [value]="item">{{item}}</option>
                                      </select>
                                    </td>

                                    <td>
                                      <select class="form-control inputWidth" formControlName="country">
                                        <option selected value="">Select Country</option>
                                        <option *ngFor="let item of countries" [value]="item">{{item}}</option>
                                      </select>
                                    </td>

                                    <td><input class="form-control inputWidth" formControlName="pincode"></td>

                                  </tr>
                                </tbody>
                              </table>
                            </div>

                          </form>
                        </div>
                      </div>

                    </div>
                    <div class="modal-footer" id="divAuthorFooter">
                      <button class="btn btn-primary" (click)="addContributor()">Add Row</button>

                      <button class="btn btn-success" (click)="submit()">Save</button>

                      <button type="button" class="btn btn-outline-danger waves-effect waves-light"
                              data-dismiss="modal" (click)="hideAuthorData()">
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="tab-pane" id="graph-view" role="tabpanel">

            <div id="divTabPanelView">
              <div class="col-xl-12" style="display:none">
                <div class="row">
                  <div class="col-sm-13">
                    <div class="card1">
                      <div class="card-body1">
                        <div class="d-flex align-items-center mb-3">
                          <div class="avatar-xs me-3"><span class="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-20"> <em class="bx bx-copy-alt"></em> </span></div>
                          <h4 class=" mb-0">{{modelData.NewArticles}}</h4>
                        </div>
                        <div class="text-muted mt-4">
                          <div class="d-flex">
                            <span class="ms-2 text-truncate">New Articles</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-13">
                    <div class="card1">
                      <div class="card-body1">
                        <div class="d-flex align-items-center mb-3">
                          <div class="avatar-xs me-3"><span class="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-20"> <em class="mdi mdi-av-timer"></em> </span></div>
                          <h4 class="mb-0">{{modelData.WIP}}</h4>
                        </div>
                        <div class="text-muted mt-4">
                          <div class="d-flex">
                            <span class="ms-2 text-truncate">Work in Progress</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-13">
                    <div class="card1">
                      <div class="card-body1">
                        <div class="d-flex align-items-center mb-3">
                          <div class="avatar-xs me-3">
                            <span class="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-20">
                              <i class="mdi mdi-notebook-edit-outline"></i>
                            </span>
                          </div>
                          <h4 class="mb-0">{{modelData.Published}}</h4>
                        </div>
                        <div class="text-muted mt-4">
                          <div class="d-flex">
                            <span class="ms-2 text-truncate">Published</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-13">
                    <div class="card1">
                      <div class="card-body1">
                        <div class="d-flex align-items-center mb-3">
                          <div class="avatar-xs me-3">
                            <span class="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-20">
                              <i class="mdi mdi-motion-pause-outline"></i>
                            </span>
                          </div>
                          <h4 class="mb-0">{{modelData.Withdrawn}}</h4>
                        </div>
                        <div class="text-muted mt-4">
                          <div class="d-flex">
                            <span class="ms-2 text-truncate">On Hold</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end row -->

              </div>
              <div class="row" style="display:none">
                <div class="col-lg-3 col-6">
                  <!-- small card -->
                  <div class="small-box bg-light">
                    <div class="inner">
                      <h3>{{modelData.NewArticles}}</h3>
                      <p>New Articles</p>
                    </div>
                    <div class="icon">
                      <i class="fa fa-book"></i>
                    </div>
                    <a routerLink="/articles" class="small-box-footer">
                      More info <i class="fas fa-arrow-circle-right"></i>
                    </a>
                  </div>
                </div>
                <!-- ./col -->
                <div class="col-lg-3 col-6">
                  <!-- small card -->
                  <div class="small-box bg-light">
                    <div class="inner">
                      <h3>{{modelData.WIP}}</h3>
                      <p>WIP</p>
                    </div>
                    <div class="icon">
                      <i class="fa fa-cogs"></i>
                    </div>
                    <a routerLink="/articles" class="small-box-footer">
                      More info <i class="fas fa-arrow-circle-right"></i>
                    </a>
                  </div>
                </div>
                <!-- ./col -->
                <div class="col-lg-3 col-6">
                  <!-- small card -->
                  <div class="small-box bg-light">
                    <div class="inner">
                      <h3>{{modelData.Published}}</h3>
                      <p>Published</p>
                    </div>
                    <div class="icon">
                      <i class="fa fa-pen"></i>
                    </div>
                    <a routerLink="/articles" class="small-box-footer">
                      More info <i class="fa fa-arrow-circle-right"></i>
                    </a>
                  </div>
                </div>
                <!-- ./col -->
                <div class="col-lg-3 col-6">
                  <!-- small card -->
                  <div class="small-box bg-light">
                    <div class="inner">
                      <h3>{{modelData.Withdrawn}}</h3>
                      <p>Hold</p>
                    </div>
                    <div class="icon">
                      <i class="fa fa-ban"></i>
                    </div>
                    <a routerLink="/articles" class="small-box-footer">
                      More info <i class="fas fa-arrow-circle-right"></i>
                    </a>
                  </div>
                </div>
                <!-- ./col -->
              </div>
            </div>

            <div class="row" id="maingraph">

              <div class="col-sm-6">
                <highcharts-chart [Highcharts]="highchartsCol"
                                  [options]="chartOptionsCol"
                                  style="width: 100%; height: 400px; display: block;">
                </highcharts-chart>
              </div>

              <div class="col-sm-6">
                <highcharts-chart [Highcharts]="highchartsPie"
                                  [options]="chartOptions"
                                  style="width: 100%; height: 400px; display: block;">
                </highcharts-chart>
              </div>

            </div>

            <div class="row" id="artgraph" style="display:none;">
              <div class="col-sm-12">
                <highcharts-chart [Highcharts]="highchartsArtCol"
                                  [options]="chartOptionsartCol"
                                  style="display:flex;">
                </highcharts-chart>
              </div>
            </div>

          </div>



        </div>
      </div>
    </div>
  </div>
</div>

<!-- Wip and Published Articles Show Popup-->
<div class="modal" id="updatetablevalue" [style.display]="showpopupModal ? 'block' : 'none'">
  <div class="modal-dialog modal-xl custome-modal">
    <div class="modal-content" id="modal_contentArt">
      <!--popup Header-->
      <div class="modal-header">
        <h4 class="modal-title">{{Artpopuptitle}}</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="Artpopuphide()">×</button>
      </div>
      <!--popup body-->
      <div class="modal-body" style="overflow:hidden !important" id="popupbody">
        <table #dataTableBudgetArticle class="display" style="width:100%"></table>
        <!--<div class="col-12 table-container">
          <div class="form-group fixTableHead">
            <table id="tblArtDetails" class="table" style="width: 100%">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Article Id</th>
                  <th>Article Type</th>
                  <th>Days at Current Status</th>
                  <th>DOI</th>
                  <th>Pub Date</th>
                  <th>Status</th>
                  <th>MS Page</th>
                  <th>Status Due Date</th>
                  <th>SI.Title</th>
                  <th>Notes</th>
                  <th>Due Date</th>
                  <th>IsHold</th>
                </tr>
              </thead>
              <tbody>
              </tbody>
            </table>
          </div>
        </div>-->
      </div>
      <!--popup body end-->
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="Artpopuphide()">Close</button>
      </div>
    </div>
  </div>
</div>
